export default __webpack_public_path__ + "static/media/cal_mob.6ace6e1b.png";